import { jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
const MenuList = ({
  children,
  css: cssProp,
  className,
  style,
  hidden
}) => /* @__PURE__ */ jsx(Box, { asChild: true, className, css: {
  listStyle: "none",
  padding: "none",
  margin: "none",
  ...cssProp
}, style, children: /* @__PURE__ */ jsx("ul", { hidden, children }) });
export {
  MenuList as default
};
